import React from 'react';
import {Link } from "react-router-dom";
import Actions from '../../helpers/actions';
import Functions from '../../helpers/functions';
import Locale from '../../assets/languages/locale.json';

import TipBox from '../../components/tipBox';
import ProjectItem from '../../components/projectItem';

import {FormattedMessage,FormattedNumber,FormattedDate,FormattedTime,FormattedRelativeTime} from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faLifeRing, faChevronRight,faChevronLeft, faEnvelope, faInfoCircle, faSignOutAlt,faFileExport,faFileDownload,faFilePdf} from '@fortawesome/pro-regular-svg-icons'
import { StickyContainer, Sticky } from 'react-sticky';
import Stepper from 'react-stepper-horizontal';
import CsvDownloader from 'react-csv-downloader';
import ReactPaginate from 'react-paginate';

import Select from 'react-select';
import {Line} from "rc-progress";
import Highcharts from 'highcharts';
import {
    HighchartsChart,
    Chart,
    withHighcharts,
    XAxis,
    YAxis,
    Tooltip,
    Title,
    Subtitle,
    Legend,
    LineSeries,
    SplineSeries,
    PieSeries
} from 'react-jsx-highcharts';
import Avatar from "react-avatar";
import ContentLoader from "react-content-loader";


const selectStyle = {
    option: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        position:'relative',
        zIndex:1005
    }),
}


class Projects extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterData:{
                customer:[],
                type:[],
            },
            filter:{
                customer:{ value: '0', label: 'All' },
                type:{ value: '0', label: 'All' },
                order:{ value: 'time_az', label: 'Süreç (Başlangıç-Bitiş)' }
            },
            data:[],
            searchKey:""
        };
        Highcharts.setOptions(Locale.tr.dateTime);
        Actions.register("closeSidePanel",this.closeSidePanel.bind(this));
    }
    componentDidMount(){
        this.getProjects();
        this.getFilters();
    }
    closeSidePanel(){
        this.getProjects();
    }

    async getFilters(){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI("/projects/filter/get",{});

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){

                this.setState({filterData:response.data},()=>{

                });
            } else {

            }
        } catch(error) {

        }
    }
    async getProjects(){
        this.setState({data:[],loading:true});
        try {
            var url = Functions.generateURI("/projects/get",{q:this.state.searchKey, customer:this.state.filter.customer.value, type:this.state.filter.type.value, order:this.state.filter.order.value});

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.setState({data:response.data},()=>{

                });
            } else {

            }
        } catch(error) {

        }
    }
    changeFilter(target,value){
        var filter = this.state.filter;
        filter[target] = value;
        this.setState({filter:filter},()=>{
            this.getProjects();
        });
        return false;
    }
    render(){
        return (
            <div id={"projects"}>
                <StickyContainer>
                    <div className={"row"}>
                        <div className={"columns small medium-12"}>
                            <Sticky topOffset={-38}>

                                {({
                                      isSticky,
                                      style,
                                  }) => (
                                    <div id={"filter"} className={"columns small-12 block noMargin"} style={{...style, marginTop: isSticky ? '38px' : '0px'}} >
                                        <div>
                                            <div className="row">
                                                <div className="columns small-2">
                                                    <div className="inputHeader">Customers</div>
                                                    <Select
                                                        styles={selectStyle}
                                                        value={this.state.filter.customer}
                                                        onChange={(val)=>{
                                                            this.changeFilter("customer",val);
                                                        }}
                                                        options={this.state.filterData.customer}
                                                    />
                                                </div>
                                                <div className="columns small-2">
                                                    <div className="inputHeader">Trailer type</div>
                                                    <Select
                                                        styles={selectStyle}
                                                        value={this.state.filter.type}
                                                        onChange={(val)=>{
                                                            this.changeFilter("type",val);
                                                        }}
                                                        options={this.state.filterData.type}
                                                    />
                                                </div>
                                                <div className="columns">
                                                    <div className={"row align-right"}>
                                                        <div className="columns small-4">
                                                            <div className="inputHeader">Search</div>
                                                            <input type={"text"} placeholder={"Enter search key.."}
                                                                   value={this.state.searchKey}
                                                                   onChange={(e) => {
                                                                       this.setState({searchKey:e.target.value},()=>{
                                                                           this.getProjects();
                                                                       });
                                                                   }}/>
                                                        </div>
                                                        <div className="columns small-4" style={{display:"none"}}>
                                                            <div className="inputHeader">Sıralama</div>
                                                            <Select
                                                                styles={selectStyle}
                                                                value={this.state.filter.order}
                                                                onChange={(val)=>{
                                                                    this.changeFilter("order",val);
                                                                }}
                                                                options={[
                                                                    { value: 'time_az', label: 'Süreç (Başlangıç-Bitiş)' },
                                                                    { value: 'time_za', label: 'Süreç (Bitiş-Başlangıç)' },
                                                                    { value: 'name_az', label: 'Müşteri A-Z' },
                                                                    { value: 'name_za', label: 'Müşteri Z-A' },
                                                                ]}
                                                            />
                                                        </div>
                                                        <div className={"column shrink noPaddingLeft"} style={{display:"none"}}>
                                                            <CsvDownloader
                                                                filename="uyeler"
                                                                separator=";"
                                                                columns={[{
                                                                    id: 'first',
                                                                    displayName: 'First column'
                                                                }, {
                                                                    id: 'second',
                                                                    displayName: 'Second column'
                                                                }]}
                                                                datas={[{
                                                                    first: 'foo',
                                                                    second: 'bar'
                                                                }, {
                                                                    first: 'foobar',
                                                                    second: 'foobar'
                                                                }]}>
                                                                <div className={"export"}><FontAwesomeIcon icon={faFileDownload} size="1x"/></div>
                                                            </CsvDownloader>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Sticky>
                            <div className={"columns small-12 block marginTop"}>
                                <div className="list">
                                    <div className={"header row"}>
                                        <div className={"columns shrink"}>
                                            <div className={"title"}><b>Müşteri</b></div>
                                        </div>
                                        <div className={"columns shrink"}>
                                            <div className={"projectName"}><b>Teklif</b></div>
                                        </div>
                                        <div className={"columns shrink"}>
                                            <div className={"projectSteps"}><b>Süreç</b></div>
                                        </div>
                                        <div className={"columns"}>
                                            &nbsp;
                                        </div>
                                    </div>
                                    <div className={"container"}>
                                        <ul>
                                            {this.renderItemList()}
                                        </ul>
                                        <div className={"pagination"} style={{display:"none"}}>
                                            <ReactPaginate
                                                previousLabel={<FontAwesomeIcon icon={faChevronLeft} size="lg"/>}
                                                nextLabel={<FontAwesomeIcon icon={faChevronRight} size="lg"/>}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={22}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={()=>{
                                                    Functions.scrollTo(0);
                                                }}
                                                containerClassName={'pagination'}
                                                subContainerClassName={'pages pagination'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </StickyContainer>
            </div>
        );
    }
    async convertWorkOrder(id){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI("/projects/convertToWorkOrder",{
                id:id,
                method:"POST"
            });

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.getProjects();
            } else {

            }
        } catch(error) {

        }
    }
    async convertOrder(id,rid){
        this.setState({loading:true});
        try {
            var url = Functions.generateURI("/projects/convertToOrder",{
                id:id,
                rid:rid,
                method:"POST"
            });

            var response = await fetch(url.address, url.header);
            response = await response.json();

            if(response.status){
                this.getProjects();
            } else {

            }
        } catch(error) {

        }
    }
    renderItemList(){
        if(this.state.data.length > 0){
            return this.state.data.map((data,key)=>{
                if(Actions.hasAccess(2)){
                    return (<ProjectItem revisePapers={this.props.revisePapers.bind(this)} revisePackingList={this.props.revisePackingList.bind(this)} reviseOffer={this.props.reviseOffer.bind(this)} key={"project_"+key} data={data} convertWorkOrder={this.convertWorkOrder.bind(this)} convertOrder={this.convertOrder.bind(this)} openOrderForm={this.props.openOrderForm.bind(this)} openWorkOrderForm={this.props.openWorkOrderForm.bind(this)} openSidePanel={this.props.openSidePanel.bind(this)}/>);
                }
            });
        } else {
            var shimmers = [{},{},{},{},{},{},{},{},{},{}];
            return shimmers.map((data,i)=>{
                return(
                    <li className={"row shimmer"} key={"u_"+i}>
                        <div className={"columns small-12"}>
                            <ContentLoader
                                width={1350}
                                height={50}
                            >
                                <rect x="0" y="0" rx="25" ry="25" width="50" height="50" />
                                <rect x="60" y="7" rx="4" ry="4" width="240" height="16" />
                                <rect x="60" y="30" rx="4" ry="4" width="240" height="10" />
                                <rect x="350" y="7" rx="4" ry="4" width="300" height="16" />
                                <rect x="350" y="30" rx="4" ry="4" width="300" height="10" />
                                <rect x="786" y="0" rx="25" ry="25" width="50" height="50" />
                                <rect x="856" y="0" rx="25" ry="25" width="50" height="50" />
                                <rect x="926" y="0" rx="25" ry="25" width="50" height="50" />
                                <rect x="996" y="0" rx="25" ry="25" width="50" height="50" />
                                <rect x="1066" y="0" rx="25" ry="25" width="50" height="50" />
                                <rect x="1170" y="0" rx="25" ry="25" width="50" height="50" />
                            </ContentLoader>
                        </div>
                    </li>
                );
            })
        }
    }
}
export class ProjectsMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    componentDidMount(){

    }
    render(){
        if(Actions.hasAccess(1)){
            return (
                <div>
                    <a style={{marginRight:6}} onClick={()=>{
                        var id = prompt("Form id giriniz", "");
                        var data = {
                            "offerName":"asd",
                            "material":{"value":1,"label":"CARBON STEEL"},
                            "brand":{"value":1,"label":"Doğan Yıldız"},
                            "customer":{"value":1,"label":"Mikedana Nig. Ltd. (#1)"},
                            "model":{"value":id,"label":"RIGID TRUCK","childs":[{"id":6,"name":"LPG","TemplateCode":id,"value":null,"childs":[]},{"id":7,"name":"PETROLEUM","TemplateCode":"78","value":null,"childs":[]},{"id":8,"name":"SILO","TemplateCode":"80","value":null,"childs":[]},{"id":9,"name":"TIPPER","TemplateCode":null,"value":null,"childs":[]},{"id":10,"name":"AMMONIUM","TemplateCode":null,"value":null,"childs":[]}]},
                            "type":{"value":6,"label":"LPG","templateCode":id}
                        }
                        this.props.openOfferForm(data);
                    }} className={"button green"}>+</a>
                    <a onClick={()=>{
                        this.props.openPopUp("offer",0);
                    }} className={"button green"}>Create new offer</a>
                </div>
            );
        }
    }
}

export default withHighcharts(Projects, Highcharts);
